export const CHANGE_VIEW_MODE = '@@general/CHANGE_VIEW_MODE';
export const CHANGE_VIEW_MODE_SUCCESS = '@@general/CHANGE_VIEW_MODE_SUCCESS';
export const CHANGE_VIEW_MODE_ERROR = '@@general/CHANGE_VIEW_MODE_ERROR';

export const TOGGLE_FIXED_ALERT = '@@general/TOGGLE_FIXED_ALERT';

export const TOGGLE_GUIDES_PORTAL = '@@general/TOGGLE_GUIDES_PORTAL';

export const SET_CDN_DATA = '@@general/SET_CDN_DATA';
